




import { DateUtils } from "../utils/DateUtils";
import { EmployeApi } from "../api/EmployeApi";

export default {
    name: "TotalFrais",
    props: {
        employeId: Number,
        selectedMonth: DateUtils.Month,
    },
    data() {
        return {
            noteDeFrais: null,
            selectedEmployeId: null,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.selectedEmployeId = this.employeId;
        this.getNoteDeFrais();
    },
    methods: {
        getNoteDeFrais() {
            let self = this;
            if (!self.selectedEmployeId || !self.selectedMonth) {
                return;
            }
            self.EmployeApi.getNoteDeFrais(
                self.selectedEmployeId,
                self.selectedMonth
            )
                .then(function (noteDeFrais) {
                    return (self.noteDeFrais = noteDeFrais);
                })
                .catch(function (error) {
                    return (self.noteDeFrais = null);
                });
        },
    },
    computed: {
        total() {
            return this.noteDeFrais ? this.noteDeFrais.total.toFixed(2) : 0;
        },
    },
    watch: {
        selectedMonth: "getNoteDeFrais",
    },
};
